<template>
  <div :class="['btn-wraper', {'offline_offsite_wraper': offline_offsite}, {'new-btn-wraper': isNewFunnel}, `${page_style}`]"  v-show="show">
    <p v-if="offline_offsite" class="text-link">
      <span @click="showSite">{{offline_offsite.title}}</span>
    </p>
    <input
      type="button"
      :value="formItem.title"
      :class="{'btn-photoinfo':1,'btn-photoinfo-active':finished}"
      :disabled="!finished"
      @click="goResult"
    />
    <offline-site ref="offlineSite" :config="offline_offsite||{}"></offline-site>
  </div>
</template>
<script>
import OfflineSite from "./offline-site";
import { ends } from "../../tools/constant";
import { getEnd } from "../../tools/utils";
import { SUPPORT_COUNTRY } from "../../tools/constant";
export default {
  props: ["formItem", "idx", "cm", "is_finished", "page_style"],
  components: { OfflineSite },
  data() {
    return {
      ends
    }
  },
  computed: {
    offline_offsite() {
      return this.formItem["attach-link"];
    },
    show() {
      let end = getEnd();
      let d = this.formItem.display;
      if (!d) {
        return true;
      }
      return d.indexOf(end) > -1;
    },
    finished(){
      //端外均可下载
      if (this.formItem.link_type === "download") {
        return true
      }else{
        return this.is_finished
      }
    },
    isNewFunnel() {
      return ["h5_funnel", "h5_funnel_fleet", "h5_funnel_fleet_pc"].includes(this.page_style);
    },
  },
  methods: {
    showSite() {
      if (this.offline_offsite.target == "blank") {
        if (!!Fusion.openPage) {
          Fusion.openPage && Fusion.openPage({
            url: this.offline_offsite.link,
            newWindow: true,
          });
        } else {
          location.href = this.offline_offsite.link;
        }
        
        return;
      }
      this.$refs.offlineSite.getLineSite();
      this.$refs.offlineSite.show();
    },
    goResult() {
      if (this.formItem.link_type === "download") {
          //端外页面直接到下载页面
          let { ios, android } = this.formItem.to;
          if (this.ends.isPC) {
            window.open(android, "_blank");
          } else if (this.ends.isIOS) {
            window.open(ios, "_blank");
          } else if (this.ends.isAndroid) {
            window.open(android, "_blank");
          } else {
            window.open(android, "_blank");
          }
      }else if (this.is_finished) {
        //添加一个关闭当前页面的逻辑 否则跳回道结果页面
        if (this.formItem.link_type === "goback_bridge") {
          Fusion.closePage &&
          Fusion.closePage({ needs_intercept: true }, () => {});
        }else{
          let up = new URLSearchParams(location.search);
          let country = up.get("location_country");
          let router = this.formItem.router || "result";
          this.$router.push({ name: `${router}${SUPPORT_COUNTRY[country]||"Mx"}` });
        }
      }
    }
  },
  mounted() {
    //更新按钮
    this.$emit("form-update", this.idx);
    if (this.offline_offsite) {
      let btn_dom = document.querySelector('.photo-info.has-btn.has-new-btn');
      btn_dom && (btn_dom.style.paddingBottom = '2.9rem')
    }
  },
  watch: {
    is_finished(newVal) {
      if (newVal) {
        this.$emit("form-update", this.idx);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-wraper {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0.43rem 0.31rem;
  .btn-photoinfo {
    width: 6.84rem;
    height: 1.06rem;
    font-size: 0.4rem;
    color: #999;
    text-align: center;
    background-color: #eee;
    border-radius: 0.06rem;
  }
  .btn-photoinfo-active {
    color: #fff;
    background: linear-gradient(45deg, #ff5b1d, #ff7f41);
  }
}
.btn-wraper.new-btn-wraper {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0;
  padding: 0.43rem 0.31rem;
  background: #fff;
  box-shadow: 0px -20px 20px 0px rgba(0,0,0,0.04);
  z-index: 1;
  &.h5_funnel_fleet,
  &.h5_funnel_fleet_pc {
    .btn-photoinfo {
      font-size: 0.4rem!important;
      color: #999999;
      background: #E9ECEE;
      border-radius: 0.2rem;
    }
    .btn-photoinfo-active {
      color: #fff;
      background: linear-gradient(145deg, #FF7D41 0%, rgba(255,116,15,0.75) 99%);
    }
  }
  &.h5_funnel_fleet_pc {
    position: relative;
    padding: 0 32px 100px 32px;
    margin-top: 64px;
    box-shadow: none;
    .btn-photoinfo {
      padding: 0;
      width: 100%;
      height: 52px;
      border-radius: 10px;
      font-size: 20px !important;
      font-weight: 700;
      border: none !important;
    }
  }
  .btn-photoinfo {
    width: 6.84rem;
    height: 1.06rem;
    font-size: 0.36rem;
    color: #fff;
    font-weight: 700;
    text-align: center;
    background: #CCCCCC;
    border-radius: 0.12rem;
  }
  .btn-photoinfo-active {
    color: #fff;
    background: linear-gradient(45deg, #ff5b1d, #ff7f41);
  }
}
.has-img-fixed .btn-wraper {
  bottom: 3.9rem;
}
</style>
